<div nz-row nzJustify="center">
  <div nz-col nzSpan="14" class="container">
    <h1>Hello, {{ name$ | async }}</h1>
    Please select a role in order to continue.
    <button
      class="role-button"
      nz-button
      nzType="primary"
      nzBlock
      *ngFor="let role of listOfRoles; trackBy: trackByRef"
      (click)="selectRole(role)"
    >
      {{ role }}
    </button>
    <button
      class="role-button"
      nz-button
      nzType="primary"
      nzBlock
      (click)="selectRole('Admin')"
      *ngIf="isAdmin$ | async"
    >
      Admin
    </button>
  </div>
</div>
